/// <amd-module name="SuiteCommerce.CookieConsent.CookieConsentLinkCCT.CookieConsentCCT"/>
define("SuiteCommerce.CookieConsent.CookieConsentLinkCCT.CookieConsentCCT", ["require", "exports", "SuiteCommerce.CookieConsent.CookieConsentLinkCCT.CookieConsentCCT.View"], function (require, exports, CookieConsentCCT_View_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            var cms = container.getComponent('CMS');
            cms.registerCustomContentType({
                id: 'cct_sc_cookie_consent_link',
                view: CookieConsentCCT_View_1.CookieConsentCCTView,
                options: {
                    container: container
                }
            });
        }
    };
});
